import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_017_itemgroup_add: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Item group",
    screenId: "17",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "ItemGroup_Add",
        TableName: "item_group",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_name",
            BindValue: "txt_name",
            label: "Name",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "group_name",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Name is required",
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Save",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
